import React, { useContext, useCallback } from 'react';
import { DateRangeFilter, RouteFilter, VehicleTypeFilter, BusinessFilter } from 'modules/filters';

import FleetFiltersContext from 'modules/fleet/filters/context';
import { useSelector } from 'react-redux';
import { constants, getClientConfig } from 'redux/modules/client-config/selectors';

const filterWidth = (width) => ({ style: { minWidth: width, maxWidth: width } });

const FleetFilters = ({ className, activeFilters, appendFilters }) => {
  const { filters, setFilters } = useContext(FleetFiltersContext);

  const FILTERS = useSelector((state) => getClientConfig(state, constants.FILTERS));

  const defaultActiveFilters = {
    businessFilter: FILTERS[constants.FLEET_BUSINESS],
    dateFilter: true,
    routeFilter: true,
    vehicleTypeFilter: FILTERS[constants.FLEET_VEHICLE_TYPE],
  };

  activeFilters = activeFilters || defaultActiveFilters;

  const handleDateChange = useCallback(
    (value) => {
      setFilters((ownFilters) => ({
        ...ownFilters,
        date: value,
      }));
    },
    [setFilters]
  );

  const handleRouteChage = useCallback(
    (value) => {
      setFilters((ownFilters) => ({
        ...ownFilters,
        route: value,
      }));
    },
    [setFilters]
  );

  const handleVehicleTypeChange = useCallback(
    (value) => {
      setFilters((ownFilters) => ({
        ...ownFilters,
        vehicle_type: value,
      }));
    },
    [setFilters]
  );

  const handleBusinessFilter = useCallback(
    (value) => {
      setFilters((ownFilters) => ({
        ...ownFilters,
        business: value,
      }));
    },
    [setFilters]
  );

  return (
    <div className={className} data-testid="FleetFilters">
      {activeFilters?.businessFilter && (
        <div className="filter" {...filterWidth('75px')} data-testid="businessFilter">
          <BusinessFilter onChange={handleBusinessFilter} value={filters?.business} />
        </div>
      )}
      {activeFilters?.dateFilter && (
        <div className="filter" {...filterWidth('240px')} data-testid="dateFilter">
          <DateRangeFilter
            onChange={handleDateChange}
            value={filters?.date}
            dateFormat="YYYY-MM-DD"
          />
        </div>
      )}
      {activeFilters?.routeFilter && (
        <div className="filter" {...filterWidth('240px')} data-testid="routeFilter">
          <RouteFilter onChange={handleRouteChage} value={filters?.route} />
        </div>
      )}
      {activeFilters?.vehicleTypeFilter && (
        <div className="filter" {...filterWidth('240px')} data-testid="vehicleFilter">
          <VehicleTypeFilter onChange={handleVehicleTypeChange} value={filters?.vehicle_type} />
        </div>
      )}
      {appendFilters}
    </div>
  );
};

export default FleetFilters;
